import { TableCell } from "@mui/material";
import * as IconMui from "@mui/icons-material";
import Tooltip from "../../../tooltip";
 
export type TIconDg = {
  icon: keyof typeof IconMui;
  bgColor: string;
  tooltip: string;
};

export const IconDg: React.FC<TIconDg> = (col) => {
  const createIcon = (col: TIconDg) => {
    const Icon = IconMui[col.icon];
    return (
      <Icon
        style={{
          color: col.bgColor,
        }}
      />
    );
  };

  return (
    <>
      <TableCell>
        <Tooltip title={col.tooltip} arrow placement="top">
          {createIcon(col)}
        </Tooltip>
      </TableCell>
    </>
  );
};
